import React, { useEffect, useState } from 'react';
import { MarkDown } from '@/components/MarkDown'
import './index.less';

export default () => {

  const [code, setCode] = useState('')

  useEffect(() => {
    getMd()
  }, [])

  const getMd = async () => {
    let res = await (await fetch(`${process.env.REACT_APP_STATUS_ERROR}?m=${Math.random()}`)).text()
    setCode(res)
  }


  return <div className='baseBox'>
    <MarkDown code={code} />
  </div>
}